import React from "react";

import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import view from "../../static/images/browser.svg";
import code from "../../static/images/web-development.svg";

const ProjectItem = ({ project }) => {
  const matchesSm = useMediaQuery("(max-width:1280px)");

  return (
    <Grid
      container
      style={matchesSm ? { marginBottom: "8rem" } : { marginBottom: "7rem" }}
    >
      <Grid item style={{ marginRight: "1rem" }}>
        <h2 className="project-item">#{project.id}</h2>
      </Grid>

      <Grid item lg md sm xs style={{ marginRight: "4rem" }}>
        <a href={project.liveURL} target="__blank" className="project-item">
          <h2>
            <span
              style={{
                padding: "0.2rem 0.5rem 0.3rem",
                color: "#222831",
                backgroundColor: "#EEEEEE",
                marginBottom: "2rem",
              }}
            >
              {project.name}
            </span>
          </h2>
        </a>

        <Grid container style={{ marginTop: "2.5rem" }}>
          <Grid item style={{ marginRight: "2rem" }}>
            <a href={project.liveURL} target="__blank" className="project-item">
              <img
                src={view}
                alt="view"
                style={{
                  width: "3rem",
                  height: "3rem",
                }}
                className="project-action-icon"
              />
            </a>
          </Grid>
          <Grid item>
            <a href={project.codeURL} target="__blank" className="project-item">
              <img
                src={code}
                alt="view"
                style={
                  project.codeURL !== ""
                    ? { width: "3rem", height: "3rem" }
                    : {
                        width: "3rem",
                        height: "3rem",
                        opacity: "0.25",
                      }
                }
                className={project.codeURL !== "" ? "project-action-icon" : ""}
              />
            </a>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        lg={4}
        md={12}
        sm={12}
        xs={12}
        style={matchesSm ? { margin: "3rem 0" } : { marginRight: "6rem" }}
      >
        <h2 className="project-item">{project.description}</h2>
      </Grid>

      <Grid item lg={4} md={12} sm={12} xs={12}>
        <h2 style={{ color: "#FFE665" }} className="project-item">
          Technologies used
        </h2>
        <br className="project-item" />
        <h2 className="project-item">{project.technologies}</h2>
      </Grid>
    </Grid>
  );
};

export default ProjectItem;
